module.exports = __webpack_public_path__ + "static/sport/out6.d21e696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out6.png
// module id = 41Eq
// module chunks = 0